const studyDegrees = [
    {
      name: "Bachelor"
    },
    {
      name: "Master",
    },
    {
      name: "PHD",

    }
  ];
  
  export default studyDegrees;  